import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propStr } from '../../../../helpers/custom-prop-types';
const AccountAddButton = (props) => {
    const { onClick, text } = props;
    return (_jsx("div", Object.assign({ className: 'account_add_button_row' }, { children: _jsxs("button", Object.assign({ className: 'account_add_button', onClick: onClick, type: 'button' }, { children: [_jsx("i", { className: 'css_plus_icon' }), _jsx("span", Object.assign({ className: 'add_button_text' }, { children: text }))] })) })));
};
AccountAddButton.propTypes = {
    onClick: propFunc().isRequired,
    text: propStr().isRequired,
};
export default AccountAddButton;
